export enum IntakeStatus {
    'DRAFT' = 'DRAFT',
    'COMPLETE' = 'COMPLETE',
}
